export default {
  INTRODISPLAYED ({ statusIntroDisplayed }) {
    return statusIntroDisplayed
  }
}
